module.exports = __webpack_public_path__ + "img/enemy_4.fb8910b8.png";